"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font = require("@headspace/hs-web-style-guide/dist/font");

var breakpoints = require("@headspace/hs-web-style-guide/dist/breakpoints");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

exports.tabBar = hs_web_style_guide_1.css(flex.justifyContentCenter, flex.alignItemsCenter, (_a = {
  backgroundColor: colors_1.merino,
  color: colors_1.silverChalice,
  overflow: 'scroll'
}, _a[breakpoints.maxWidths.s] = {
  width: '100%'
}, _a));
exports.tabList = hs_web_style_guide_1.css(flex.flex, flex.row, {
  listStyle: 'none',
  padding: 0
});
exports.tabBarUnderline = hs_web_style_guide_1.css(flex.flex, flex.row, {
  height: 8
});
exports.tabUnderline = hs_web_style_guide_1.css(flex.flex1, flex.flexBasis0, {
  cursor: 'pointer',
  height: 8
});
exports.tabActive = hs_web_style_guide_1.css({
  color: colors_1.comet
});
exports.tabUnderlineActive = hs_web_style_guide_1.css({
  backgroundColor: colors_1.comet
});
exports.tabUnderlineInactive = hs_web_style_guide_1.css({
  backgroundColor: colors_1.carrarra
});
exports.tab = hs_web_style_guide_1.css(flex.justifyContentCenter, flex.flex1, flex.flexBasis0, font.utility2, {
  backgroundColor: colors_1.merino,
  textAlign: 'center',
  cursor: 'pointer',
  textTransform: 'uppercase'
});